import { FC } from "react";
import { Box, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import { usePageTitle } from "@Hooks/usePageTitle";
import { Button } from "@Components/Button";
import { keycloakService } from "@Services/keycloak";

/**
 * Tela de ACESSO NEGADO por PAPEL: o usuário autenticou no SSO, mas não tem
 * nenhuma das roles da ferramenta (analise_dados_base / analise_dados_externos).
 * Diferente de AuthorizationError (falha técnica de auth) — aqui o login funcionou,
 * só falta autorização. Mostra o e-mail logado (para pedir liberação) e "Sair".
 */
export const AcessoNegado: FC = () => {
  usePageTitle("Sem acesso");
  const email = localStorage.getItem("userEmail") || "";

  return (
    <Flex minH="100vh" align="center" justify="center" p="24px">
      <Box
        bg="neutrals.surface.surface-0"
        borderRadius="16px"
        p="40px"
        maxW="480px"
        textAlign="center"
        border="1px solid"
        borderColor="neutrals.stroke.soft-200"
      >
        <VStack spacing={4}>
          <Heading as="h1" fontSize="22px" fontFamily="heading" color="neutrals.text.strong-950">
            Você ainda não tem acesso
          </Heading>
          <Text fontSize="sm" color="neutrals.text.sub-600" fontFamily="body">
            Seu login funcionou, mas sua conta não está autorizada a usar esta
            ferramenta. Procure o seu gestor para solicitar o acesso.
          </Text>
          {email && (
            <Text fontSize="sm" color="neutrals.text.strong-950" fontFamily="body">
              Conta: <b>{email}</b>
            </Text>
          )}
          <Box pt="4px" w="100%">
            <Button colorSchema="neutral" variant="outline" onClick={() => keycloakService.logout()}>
              Sair
            </Button>
          </Box>
        </VStack>
      </Box>
    </Flex>
  );
};
